var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalSearchSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H21V22.5H15V21ZM15 18H24V19.5H15V18ZM15 15H24V16.5H15V15Z",
    fill: "#696871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4117 8.41275L12 1.5L8.58821 8.41275L0.959961 9.52125L6.47996 14.9025L5.17646 22.5L10.5 19.7017V18.0068L7.16921 19.758L7.95821 15.156L8.09171 14.3783L7.52696 13.8285L4.18346 10.5682L8.80421 9.897L9.58421 9.78375L9.93371 9.0765L12 4.88925L14.0662 9.0765L14.4157 9.78375L15.1957 9.897L20.7862 10.7108L21 9.225L15.4117 8.41275Z",
    fill: "#696871"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchSkills);
export default __webpack_public_path__ + "static/media/global-search-skills.1e6db193.svg";
export { ForwardRef as ReactComponent };